import { dummyOpenOrders } from "../dummyData";
import {
  handleRequestError,
  hostUrl,
  jsonHeaders,
  request,
  withDummyFallback,
} from "./core";

export const listOrders = (id) => {
  if (!id) return;
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/list/orders"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id }),
  };
  return request(config)
    .then((response) => response.data)
    .catch((error) =>
      handleRequestError(error, undefined, { networkFallback: [] }),
    );
};

export const getOpenOrders = (id) => {
  if (!id) return;
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/orders"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id }),
  };
  return request(config)
    .then((response) => withDummyFallback(response.data, dummyOpenOrders))
    .catch((error) =>
      handleRequestError(error, dummyOpenOrders, {
        networkFallback: { charges: 0, data: [] },
      }),
    );
};

export const createOrders = (payload) => {
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/orders/create"),
    headers: jsonHeaders(),
    data: JSON.stringify(payload),
  };
  return request(config).catch((error) => handleRequestError(error));
};

export const deleteOrders = (id) => {
  if (!id) return;
  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: hostUrl("/users/order/delete"),
    headers: jsonHeaders(),
    data: JSON.stringify({ id }),
  };
  return request(config)
    .then((response) => response.data)
    .catch((error) => {
      handleRequestError(error);
    });
};
